import { Component, Input } from 'angular-ts-decorators';

import template from './compare-basket-toggler.component.html';

@Component({
  selector: 'compareBasketToggler',
  template,
})
export class CompareBasketTogglerComponent {
  @Input('&') public onToggle?: () => void;

  public isCollapsed = true;

  public toggle() {
    this.isCollapsed = !this.isCollapsed;
    if (this.onToggle) {
      this.onToggle();
    }
  }
}
